import "./registration.scss";
import React from "react";
import RegistrationRouter from "./routes";
import Header from "shared/components/header";
import { RegDetailProvider, useRegDetail } from "../../shared/context/regDetail";
import { StaticDataProvider } from "context/staticData";
import { useCopies } from "shared/hooks/useCopies";
import { ThemeProvider } from "context/theme";
import UiTheme from "shared/enums/UiTheme";
import FeatureControlCheck from "../../shared/components/featureControlCheck";
import TrackingType from "shared/enums/TrackingType";
import { appendStringAsHtmlInBody } from "shared/utils";
import { CommonFeaturesProvider } from "../../context/commonFeatures";
import classNames from "classnames";
import { DisplayBehaviourProvider } from "./components/displayBehaviour/displayBehaviourProvider";

export default function Registration() {
  return (
    <RegDetailProvider>
      <DisplayBehaviourProvider>
        <RegistrationWrapper />
      </DisplayBehaviourProvider>
    </RegDetailProvider>
  );
}

function RegistrationWrapper() {
  const regDetail = useRegDetail();

  React.useEffect(() => {
    if (regDetail.trackingType === TrackingType.HUBSPOT && regDetail.trackingHtml) {
      appendStringAsHtmlInBody(regDetail.trackingHtml);
    }
  }, [regDetail]);

  return (
    <StaticDataProvider localeId={regDetail.localeId}>
      <CommonFeaturesProvider>
        <FeatureControlCheck isMobileSupported={true} isTabletSupported={true}>
          <ThemeProvider clientTheme={UiTheme[regDetail.theme]}>
            <RegistrationStaticWrapper />
          </ThemeProvider>
        </FeatureControlCheck>
      </CommonFeaturesProvider>
    </StaticDataProvider>
  );
}

function RegistrationStaticWrapper() {
  const copies = useCopies();
  const [isRegFormTitleScroll, setRegFormTitleScroll] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const elementRef = ref.current;
    function handleScroll() {
      if (ref.current?.querySelector(".regFormTitle_wrapper")) {
        setRegFormTitleScroll(ref.current.scrollTop > 0);
      }
    }

    if (elementRef) elementRef.addEventListener("scroll", handleScroll, { passive: true });

    return () => elementRef?.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <React.Fragment>
      <Header portalTitle={copies.get("registration")} eventDetailsFlag={true} />
      <main ref={ref} className={classNames("regBody", { isRegFormTitleScroll })}>
        <RegistrationRouter />
      </main>
    </React.Fragment>
  );
}
